const DEFAULT_AUTH_API_BASE = "https://sandbox.avipair.com";
const DEFAULT_AUTH_REST_API_BASE =
  "https://yg0xwh6fw6.execute-api.us-east-1.amazonaws.com";

export const authApiConfig = {
  /** WAF-protected base URL used in production (signup, forgetPassword). */
  authApiBase:
    process.env.REACT_APP_AUTH_API_BASE || DEFAULT_AUTH_API_BASE,
  /** Direct API Gateway base URL — dev fallback when WAF is not configured. */
  authRestApiBase:
    process.env.REACT_APP_AUTH_REST_API_BASE || DEFAULT_AUTH_REST_API_BASE,
  wafIntegrationUrl: process.env.REACT_APP_AWS_WAF_INTEGRATION_URL || "",
  wafApiKey: process.env.REACT_APP_AWS_WAF_API_KEY || "",
};

export const isWafConfigured = () =>
  Boolean(authApiConfig.wafIntegrationUrl && authApiConfig.wafApiKey);

export const getAuthRequestBaseUrl = () =>
  isWafConfigured() ? authApiConfig.authApiBase : authApiConfig.authRestApiBase;

export default authApiConfig;
